import { Result } from "antd";
import Buttons from "../components/Buttons";
import { useEffect } from "react";

export default function Four0Four(args) {
  useEffect(() => {
    document.title = "Hata 404 | Zenofy";
  }, [args]);
  return (
    <div
      style={{
        display: "flex",
        marginTop: "3rem",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
        flexDirection: "column",
        fontFamily: "Arial",
      }}
    >
      <Result
        style={{
          fontFamily: "Arial",
        }}
        status="404"
        title={
          <h1
            style={{
              fontSize: args.device === "pc" ? "6rem" : "4rem",
              margin: "1rem",
            }}
          >
            Hata 404
          </h1>
        }
        subTitle={
          <div>
            <h2
              style={{
                fontSize: args.device === "pc" ? "4rem" : "2rem",
                margin: "1rem",
              }}
            >
              Sayfa Henüz Eklenmedi...
            </h2>
            <h3 style={{ margin: "1rem" }}>(Zenofy Beta)</h3>
          </div>
        }
        extra={<Buttons buttonsPrimary={["Eve dön"]} hrefPrimary={["/"]} />}
      />
    </div>
  );
}
